// Exports
export default {
	"wrapper": "wrapper_TG16v",
	"scaleTick": "scaleTick_efv2I",
	"active": "active_VVWRn"
};
